import { getServerProps } from './server-to-client';

export const enabledBoolOrListCheck = (variable, keyCheck) => {
  try {
    return JSON.parse(variable)
  } catch (error) {
    const list = variable?.split(',')
    return list?.some((value) => value.match(/^all$/i)) || list?.includes(keyCheck)
  }
}

export function getConfigLists() {
  const isSsr = typeof window === 'undefined';
  if (isSsr) return {};

  const {
    expConfiguration: {
      storeList,
      itemIdBlacklist,
      allowQuarterHourReservations,
      dropoffEnabled, // reservation end time
      rentalDropoffEnabled,
      rentalDropoffDisabled,
      rentalEstimateEnabled
    },
  } = !isSsr && getServerProps();

  const whitelistedStores = storeList?.split(',');
  const blacklistedItems = itemIdBlacklist?.split(',');
  const quarterHourReservationStores = allowQuarterHourReservations?.split(',');

  return {
    whitelistedStores,
    blacklistedItems,
    quarterHourReservationStores,
    dropoffEnabled,
    rentalDropoffEnabled,
    rentalDropoffDisabled,
    rentalEstimateEnabled
  };
}